// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_3MRh_","visuallyhidden":"_9eOsg","hide-text":"_16GYX","center":"hASIs","noprint":"_1cCo7","root":"_1zkzA","enabledOnMobile":"_3ytj3"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/cn-skin-vg/styles/components/SubscribeButton.scss
 ** module id = 456
 ** module chunks = 0
 **/